module.exports = __webpack_public_path__ + "static/media/Workday_Step2b_Image10.ba6f6102.jpg";